import { useEffect, useRef } from 'react';
import { getTradingViewSymbol } from '../../utils/commodities';

const TradingChart = ({ symbol, theme = 'dark' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !window.TradingView) return;

    const tradingSymbol = getTradingViewSymbol(symbol);

    try {
      // Clear any existing widget
      containerRef.current.innerHTML = '';

      // Create new TradingView widget
      new window.TradingView.widget({
        autosize: true,
        symbol: tradingSymbol,
        interval: '15',
        timezone: 'Etc/UTC',
        theme: theme,
        style: '1',
        locale: 'en',
        toolbar_bg: '#1a1a1a',
        enable_publishing: false,
        withdateranges: true,
        hide_side_toolbar: false,
        allow_symbol_change: false,
        save_image: false,
        container_id: containerRef.current.id,
        studies: [
          'MASimple@tv-basicstudies',
          'RSI@tv-basicstudies'
        ],
        backgroundColor: 'rgba(0, 0, 0, 0)',
        gridColor: 'rgba(42, 46, 57, 0.3)',
        overrides: {
          'mainSeriesProperties.candleStyle.upColor': '#10b981',
          'mainSeriesProperties.candleStyle.downColor': '#ef4444',
          'mainSeriesProperties.candleStyle.borderUpColor': '#10b981',
          'mainSeriesProperties.candleStyle.borderDownColor': '#ef4444',
          'mainSeriesProperties.candleStyle.wickUpColor': '#10b981',
          'mainSeriesProperties.candleStyle.wickDownColor': '#ef4444',
          'paneProperties.background': '#000000',
          'paneProperties.backgroundType': 'solid',
        }
      });
    } catch (error) {
      console.error('TradingView widget error:', error);
    }

    // Cleanup
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [symbol, theme]);

  return (
    <div className="w-full h-[400px] sm:h-[500px] rounded-xl overflow-hidden bg-black border border-gray-800">
      <div 
        id={`tradingview_chart_widget_${symbol}`}
        ref={containerRef}
        className="w-full h-full"
      />
    </div>
  );
};

export default TradingChart;
